const statusPorSituacao = [
    {
        regra: 'CRED-UABS-FIN-02',
        situacoes: [
            {
                id: 0,
                status: [-1, 0, 1, 4, 5, 8, 9, 12]
            },
            {
                id: 1,
                status: [-1, 0, 5]
            },
            {
                id: 2,
                status: [-1, 1, 8]
            },
            {
                id: 3,
                status: [-1, 4, 9, 12]
            }
        ]
    },
    {
        regra: 'CRED-UFI-FIN-00',
        situacoes: [
            {
                id: 0,
                status: [-1, 0, 1, 4, 5, 8, 9, 12]
            },
            {
                id: 1,
                status: [-1, 0, 1, 5, 8]
            },
            {
                id: 2,
                status: [-1, 12, 4]
            },
            {
                id: 3,
                status: [-1, 9]
            }
        ]
    }
]

export default statusPorSituacao
